"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const oneEntry_1 = require("../base/oneEntry");
/**
 * Controllers for working with system - system
 */
class SystemApi extends oneEntry_1.default {
    constructor(url, token) {
        super(url, token);
        this._url += '/api/content/system';
    }
    async test404() {
        const result = await this._fetchGet('/test404');
        return result;
    }
    async test500() {
        const result = await this._fetchGet('/test500');
        return result;
    }
}
exports.default = SystemApi;
